var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "15mm",
    height: "15mm",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#535353",
    d: "M 0.7575858,14.725566 C 0.4029504,14.51575 0.2868889,13.721939 0.2295193,11.113821 0.1890776,9.2752671 0.1208915,6.2104762 0.0779948,4.3031735 L -2e-7,0.83535047 0.9238554,0.36971717 c 0.7833401,-0.3948116 1.5668723,-0.4393265 5.1515163,-0.2926732 2.3252123,0.095128 5.2844773,0.2518931 6.5761443,0.3483667 L 15,0.60081727 V 7.6298441 C 15,13.777766 14.93992,14.680451 14.520671,14.831023 13.73533,15.113078 1.2508786,15.017419 0.7575858,14.725566 Z M 14.09091,7.6582441 V 1.4477728 L 10.075758,1.2551141 C 4.7407337,0.99912397 1.2027497,1.1382111 1.2424248,1.6023747 c 0.016667,0.1949851 0.050758,3.0346782 0.075758,6.3104284 l 0.045455,5.9559119 H 7.7272743 14.090911 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#535353",
    fillRule: "evenodd",
    d: "M 3.05,3.12 C 3.85,3.09 4.66,3.17 5.44,3.15 C 6.40,4.49 7.34,5.86 8.30,7.17 C 9.41,8.72 10.55,10.28 11.69,11.86 C 10.88,11.89 10.06,11.81 9.27,11.85 C 8.13,10.30 7.03,8.73 5.91,7.20 C 4.95,5.86 4.01,4.48 3.05,3.12 Z M 4.26,3.79 C 5.07,4.95 5.94,6.13 6.77,7.28 C 7.72,8.57 8.68,9.91 9.63,11.18 L 10.47,11.20 C 9.50,9.86 8.56,8.55 7.60,7.23 C 6.77,6.08 5.94,4.94 5.12,3.80 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#535353",
    d: "M 10.61,3.14 L 11.56,3.17 C 10.53,4.39 9.50,5.61 8.45,6.81 L 8.04,6.25 C 8.89,5.21 9.79,4.18 10.61,3.14 Z M 6.60,8.05 L 7.02,8.62 C 6.10,9.73 5.17,10.81 4.25,11.86 L 3.31,11.82 C 4.43,10.58 5.51,9.31 6.60,8.05 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.445e14134fd48bcc9893ed5f6c1186f9.svg";
export { ForwardRef as ReactComponent };